var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhale = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F78E2",
    d: "M84.453 61.284v-29.3a9.04 9.04 0 0 0-4.52-7.828L54.559 9.506a9.04 9.04 0 0 0-9.04 0l-25.374 14.65a9.04 9.04 0 0 0-4.52 7.829v29.299a9.04 9.04 0 0 0 4.52 7.828l25.374 14.65a9.04 9.04 0 0 0 9.04 0l25.374-14.65a9.04 9.04 0 0 0 4.52-7.828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M82.528 60.465V32.804a8.53 8.53 0 0 0-4.268-7.392l-23.955-13.83a8.53 8.53 0 0 0-8.535 0l-23.955 13.83a8.54 8.54 0 0 0-4.268 7.392v27.661a8.54 8.54 0 0 0 4.268 7.391l23.955 13.83a8.53 8.53 0 0 0 8.535 0l23.955-13.83a8.54 8.54 0 0 0 4.267-7.391"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M78.995 58.961V34.308a7.61 7.61 0 0 0-3.804-6.588l-21.35-12.326a7.6 7.6 0 0 0-7.606 0L24.885 27.72a7.61 7.61 0 0 0-3.804 6.588V58.96a7.61 7.61 0 0 0 3.804 6.588l21.35 12.326a7.6 7.6 0 0 0 7.606 0l21.35-12.326a7.61 7.61 0 0 0 3.804-6.588"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B81F6",
    d: "M49.446 33.006c2.037-1.796 4.23-.929 4.624.25.255.763.144 2.718-2.624 2.345-2.767-.373-4.642.739-4.642.739s.603-1.538 2.642-3.334m-1.667.224s1.131-1.94 2.972-2.33c1.772-.376 1.995-1.284 1.502-2.097-.734-1.208-2.905-.426-3.694 1.376-.83 1.9-.78 3.051-.78 3.051m-.972-2.683c-.496-2.436-3.349-3.767-4.71-2.085-1.576 1.951.002 3.157 2.173 4.395 2.17 1.237 2.237 3.092 2.237 3.092.228-1.342.773-3.081.3-5.403zm-3.37 3.144c-3.181-1.079-3.59.879-3.47 1.526.08.431.32 1.982 2.597 1.03 2.278-.953 3.643.004 3.643.004s-.823-1.9-2.77-2.559z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "whale_svg__a",
    width: 43,
    height: 43,
    x: 29,
    y: 25,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.691 25.002H29.198v42.494H71.69z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#whale_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "whale_svg__b",
    width: 42,
    height: 42,
    x: 30,
    y: 25,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.135 25.889H30.967v40.723h40.168z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#whale_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.85 50.713c-.25 1.1-1.636.61-2.424.386-.669-.191-3.141-.496-3.379-.873-.428-.675 1.14-1.23 2.466-1.447 1.368-.224 3.677.449 3.337 1.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D2F5",
    d: "M46.693 66.605c-6.583-.136-12.224-3.703-14.565-8.952a13 13 0 0 1-.523-1.37c1.479.486 5.12-4.69 10.882-3.498q.114.022.225.049c4.91 1.097 6.454 4.147 11.747 3.837 1.525.684 1.661 1.148 2.707 1.973.599.471 2.98 2.709 5.259 1.336 1.071-.596 1.126-2.38.728-4.081a8 8 0 0 0-.132-.498 10 10 0 0 0-.097-.322c5.009-2.212 8.097-7.986 8.192-13.65.496 11.698-8.044 25.516-24.423 25.175z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B81F6",
    d: "M70.601 37.229c-.608-1.529-.823-2.308-.608-4.145.162-1.005-.825-8.921-3.04-6.853-.633 1.21-2.152 7.73-2.117 7.722-.587.39-4.706 2.833-5.037 3.442 2.126 2.018 5.237-.016 7.562.965 1.404 1.418.503 3.828-.782 4.965-.715.636-1.898 1.044-3.044 1.301-1.697.383-3.479-.167-4.635-1.467-2.884-3.241-7.281-5.313-12.206-5.313-8.58 0-15.559 6.287-15.722 14.098q-.001.14-.003.281c0 1.409.222 2.771.637 4.059 1.479.485 5.12-4.693 10.883-3.499q.113.022.225.049c4.91 1.097 6.453 4.149 11.746 3.836 1.525.684 1.661 1.148 2.707 1.973.6.47 2.98 2.71 5.26 1.336 1.05-.63 1.12-2.389.727-4.08a7 7 0 0 0-.132-.499q-.046-.16-.097-.321c5.009-2.211 8.097-7.986 8.193-13.65v-.004a15 15 0 0 0-.515-4.197zM41.048 50.226c-.43-.675 1.138-1.23 2.465-1.447 1.368-.224 3.677.449 3.337 1.934-.25 1.1-1.636.61-2.424.386-.669-.19-3.141-.496-3.379-.873"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B81F6",
    d: "M46.85 50.713c-.25 1.1-1.636.61-2.424.386-.669-.191-3.141-.496-3.379-.873-.428-.675 1.14-1.23 2.466-1.447 1.368-.224 3.677.449 3.337 1.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.007,
    d: "M42.659 49.225a1.697 1.697 0 1 0 3.392 0 1.697 1.697 0 1 0-3.392 0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("mask", {
    id: "whale_svg__c",
    width: 58,
    height: 65,
    x: 21,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.995 58.979V34.32c0-2.719-1.45-5.23-3.804-6.589l-21.355-12.33a7.61 7.61 0 0 0-7.608 0l-21.356 12.33a7.61 7.61 0 0 0-3.803 6.59v24.658c0 2.719 1.45 5.23 3.803 6.589l21.356 12.33a7.61 7.61 0 0 0 7.608 0l21.355-12.33a7.61 7.61 0 0 0 3.804-6.59"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#whale_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.35-12.17-66.37 51.39L3.23 56.33 69.598 4.943zM70.827 7.096 4.457 58.485l3.352 4.328 66.37-51.389z"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    d: "M22.67 72.232c-3.844 2.021-6.64 3.983-10.071 6.563l5.321 3.487a101 101 0 0 1 10.115-7.031l-5.365-3.02zM16.92 91.793c4.961-3.555 13.654-9.476 19.606-11.762l-6.521-3.672c-3.221 1.888-7.13 4.492-11.11 7.653q0 .004-.003.007z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    d: "M28.036 75.253a101 101 0 0 0-10.115 7.031l.457.3c.482.318.677.904.516 1.43 3.98-3.16 7.889-5.765 11.11-7.652l-1.969-1.109z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    d: "M87.301 78.826c-3.43-2.58-6.227-4.541-10.07-6.563l-5.16 2.905a101 101 0 0 1 10.12 7.01l5.11-3.35zM63.375 80.062c5.953 2.285 14.644 8.206 19.606 11.761L81.01 84.05a1.3 1.3 0 0 1-.056-.354c-3.9-3.065-7.713-5.59-10.853-7.42l-6.724 3.785z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    d: "m81.523 82.614.667-.438a101 101 0 0 0-10.12-7.009l-1.971 1.11c3.14 1.83 6.952 4.355 10.852 7.42a1.26 1.26 0 0 1 .572-1.084"
  })));
};
export default SvgWhale;